import React from 'react';
import { Tag } from 'antd';
import { formatMontant } from '../../variables/constants';
import { libellesTraduits } from '../../i18n/libelles';

/* Pièces partagées par les écrans du menu Comptabilité. */

export const GREEN = '#1a6b3c';
export const ROUGE = '#b42318';

export const API_PARAMETRAGE = '/v1/comptabilite/parametrage';

export const TYPES_COMPTE = ['ACTIF', 'PASSIF', 'CHARGE', 'PRODUIT'];
export const COULEUR_TYPE = { ACTIF: 'blue', PASSIF: 'purple', PRODUIT: 'green', CHARGE: 'orange' };
export const LIBELLE_TYPE = libellesTraduits('comptabilite:typesCompte');

export const TagTypeCompte = ({ type }) => (
  <Tag color={COULEUR_TYPE[type] || 'default'} style={{ borderRadius: 20 }}>
    {LIBELLE_TYPE[type] || type}
  </Tag>
);

/** Montant d'une colonne débit/crédit : un zéro s'efface, pour que l'œil trouve le côté mouvementé. */
export const Montant = ({ valeur, gras = false }) => {
  const n = Number(valeur || 0);
  if (!n) return <span style={{ color: '#c0c4cc' }}>—</span>;
  return (
    <span style={{ fontVariantNumeric: 'tabular-nums', fontWeight: gras ? 700 : 500 }}>
      {formatMontant(n)}
    </span>
  );
};

export const somme = (lignes, cle) =>
  (lignes || []).reduce((t, l) => t + Number(l?.[cle] || 0), 0);

/** Écart toléré entre débit et crédit : un centime, comme côté serveur. */
export const equilibre = (debit, credit) => Math.abs(Number(debit || 0) - Number(credit || 0)) < 0.01;

/** Déclenche le téléchargement d'un fichier reçu en `blob` depuis le serveur. */
export const telecharger = (blob, nomFichier) => {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const a = document.createElement('a');
  a.href = url;
  a.download = nomFichier;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

/** Libellé lisible d'un type d'opération, pour les écrans qui n'ont que le code. */
export const LIBELLE_OPERATION = libellesTraduits('comptabilite:operations');
